export default __webpack_public_path__ + "static/media/fluid_droplet.077403ba.png";